<template>
  <div>
    <v-card outlined class="mb-4">
      <v-card-title class="subtitle-1 font-weight-bold">Resultado mensal — cenário base</v-card-title>
      <v-data-table
        :headers="monthlyHeaders"
        :items="results"
        no-data-text="Preencha os parâmetros na aba Projeção Heppi"
        :footer-props="{ itemsPerPageOptions: [12, 24, 66, -1] }"
        :items-per-page="12"
        dense
      >
        <template v-slot:item.periodLabel="{ item }">{{ item.periodLabel }}</template>
        <template v-slot:item.receitaBruta="{ item }">{{ item.receitaBruta | price }}</template>
        <template v-slot:item.taxaHeppi="{ item }">{{ item.taxaHeppi | price }}</template>
        <template v-slot:item.receitaLiquida="{ item }">{{ item.receitaLiquida | price }}</template>
        <template v-slot:item.saida="{ item }">{{ item.saida | price }}</template>
        <template v-slot:item.rendimento="{ item }">{{ item.rendimento | price }}</template>
        <template v-slot:item.saldoSemRendimento="{ item }">{{ item.saldoSemRendimento | price }}</template>
        <template v-slot:item.rendimentoAcumulado="{ item }">{{ item.rendimentoAcumulado | price }}</template>
        <template v-slot:item.saldoAcumulado="{ item }">{{ item.saldoAcumulado | price }}</template>
      </v-data-table>
    </v-card>

    <v-card outlined class="mb-4">
      <v-card-title class="subtitle-1 font-weight-bold">Saldo final mês a mês</v-card-title>
      <v-card-text>
        <line-chart
          v-if="results.length"
          :chart-data="chartData"
          :options="chartOptions"
          :height="120"
        ></line-chart>
        <div v-else class="text--secondary text-center py-6">Sem dados para exibir</div>
      </v-card-text>
    </v-card>

    <v-card outlined>
      <v-card-title class="subtitle-1 font-weight-bold">Resumo semestral</v-card-title>
      <v-data-table
        :headers="semesterHeaders"
        :items="semesters"
        no-data-text="Sem dados"
        hide-default-footer
        :items-per-page="-1"
        dense
      >
        <template v-slot:item.receitaBruta="{ item }">{{ item.receitaBruta | price }}</template>
        <template v-slot:item.receitaLiquida="{ item }">{{ item.receitaLiquida | price }}</template>
        <template v-slot:item.saidas="{ item }">{{ item.saidas | price }}</template>
        <template v-slot:item.rendimento="{ item }">{{ item.rendimento | price }}</template>
        <template v-slot:item.saldoFinal="{ item }">{{ item.saldoFinal | price }}</template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/huggy/LineChart'

export default {
  name: 'TabVisualizacaoTurma',
  components: { LineChart },
  props: {
    results: { type: Array, default: () => [] },
    semesters: { type: Array, default: () => [] }
  },
  data: () => ({
    monthlyHeaders: [
      { text: 'Mês', value: 'periodLabel' },
      { text: 'Receita Bruta', value: 'receitaBruta' },
      { text: 'Taxa Heppi', value: 'taxaHeppi' },
      { text: 'Receita Líquida', value: 'receitaLiquida' },
      { text: 'Saída', value: 'saida' },
      { text: 'Rendimento', value: 'rendimento' },
      { text: 'Saldo s/ Rendimento', value: 'saldoSemRendimento' },
      { text: 'Rendimento Acumulado', value: 'rendimentoAcumulado' },
      { text: 'Saldo Final', value: 'saldoAcumulado' }
    ],
    semesterHeaders: [
      { text: 'Semestre', value: 'semesterLabel' },
      { text: 'Receita Bruta', value: 'receitaBruta' },
      { text: 'Receita Líquida', value: 'receitaLiquida' },
      { text: 'Saídas', value: 'saidas' },
      { text: 'Rendimento', value: 'rendimento' },
      { text: 'Saldo Final', value: 'saldoFinal' }
    ],
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        yAxes: [{
          ticks: {
            callback: function (value) {
              return 'R$ ' + value.toLocaleString('pt-BR')
            }
          }
        }]
      }
    }
  }),
  computed: {
    chartData () {
      return {
        labels: this.results.map(r => r.periodLabel),
        datasets: [{
          label: 'Saldo Final',
          data: this.results.map(r => r.saldoAcumulado),
          borderColor: '#6a1b9a',
          backgroundColor: 'rgba(106, 27, 154, 0.1)',
          fill: true,
          pointRadius: 0,
          borderWidth: 2
        }]
      }
    }
  }
}
</script>
